import React from 'react';
import SmallerSpinner from '../../../../../components/SmallerSpinner';
import Button from '../../../../../components/Button';
import { Trash2 } from 'lucide-react';

export default function ExpiryModal({ styles, list, today, setCount, onChange, onRemove, onClose }) {
  return (
    <div className={styles.modalOverlay} role="dialog" aria-modal="true">
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h2>Edit Expiry Dates</h2>
          <button className={styles.modalCloseBtn} onClick={onClose} aria-label="Close">×</button>
        </div>
        <div className={styles.modalBody}>
          <div className={styles.icdToolbar}>
            <div className={styles.icdCountControl}>
              <SmallerSpinner compact value={list.length} onChange={setCount} ariaLabel="Number of Expiry Dates" />
            </div>
            <div className={styles.icdToolbarLabel}>Expiry</div>
          </div>
          <div className={styles.icdChipsRow}>
            {list.map((date, idx) => (
              <div className={styles.icdChip} key={idx}>
                <input className={styles.icdChipInput} type="date" value={date} min={today} onChange={e => onChange(idx, e.target.value)} />
                {list.length > 1 && (
                  <button type="button" className={styles.icdDeleteBtn} onClick={() => onRemove(idx)} aria-label="Remove">
                    <Trash2 size={14} />
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>
        <div className={styles.modalFooter}>
          <Button variant="primary" onClick={onClose}>Save</Button>
        </div>
      </div>
    </div>
  );
}
